import { webKnots } from '../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'

export const wt5Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ1
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(627, 117) //左上
  ctx.quadraticCurveTo(607, 176, 571, 220) //左下
  ctx.quadraticCurveTo(591, 240, 607, 280) //右下
  ctx.quadraticCurveTo(658, 233, 672, 184) //右上
  ctx.quadraticCurveTo(650, 141, 627, 115) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 縦パーツ2
  ctx.beginPath()
  ctx.moveTo(558, 235) //左上
  ctx.quadraticCurveTo(532, 274, 489, 312) //左下
  ctx.quadraticCurveTo(523, 362, 523, 362) //右下
  ctx.quadraticCurveTo(565, 328, 592, 292) //右上
  ctx.quadraticCurveTo(580, 255, 558, 235) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左＿外側
  ctx.moveTo(629, 123) // 上
  ctx.quadraticCurveTo(611, 177, 576, 220) // 下
  // // 縦向き＿左＿内側
  ctx.moveTo(632, 127) // 上
  ctx.quadraticCurveTo(615, 179, 579, 224) // 下
  // // 縦向き＿右＿内側
  ctx.moveTo(665, 178) // 上
  ctx.quadraticCurveTo(641, 239, 605, 267) // 下
  // // 縦向き＿右＿外側
  ctx.moveTo(668, 183) // 上
  ctx.quadraticCurveTo(647, 239, 607, 272) // 下
  // 縦＿下＿外側
  ctx.moveTo(560, 242) // 左上
  ctx.quadraticCurveTo(529, 285, 495, 311) // 左下
  ctx.quadraticCurveTo(524, 354, 524, 354) // 右下
  ctx.quadraticCurveTo(557, 328, 588, 290) // 右上
  ctx.quadraticCurveTo(578, 265, 560, 242) // 左上
  // 縦＿下＿内側
  ctx.moveTo(562, 245) // 左上
  ctx.quadraticCurveTo(533, 285, 501, 312) // 左下
  ctx.quadraticCurveTo(525, 346, 525, 346) // 右下
  ctx.quadraticCurveTo(555, 322, 583, 288) // 右上
  ctx.quadraticCurveTo(578, 269, 558, 245) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webKnots(ctx, laceColor, 25, -60) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -25, 25) // 捕球面寄りのウェブ結び目
  webKnots(ctx, laceColor, -105, 115) // 捕球面寄りのウェブ結び目
}
